import { Contract } from 'ethers';

/**
 * Ensure `spender` can pull at least `minAmount` of `token` from `signer`.
 * Approves exactly `minAmount` (not unlimited) so MetaMask shows the real cap.
 */
export async function ensureErc20Allowance(signer, tokenAddress, tokenAbi, spender, minAmount) {
  const token = new Contract(tokenAddress, tokenAbi, signer);
  const owner = await signer.getAddress();

  let allowance = await token.allowance(owner, spender);
  if (allowance >= minAmount) return token;

  const tx = await token.approve(spender, minAmount);
  await tx.wait(1);

  for (let i = 0; i < 30; i++) {
    allowance = await token.allowance(owner, spender);
    if (allowance >= minAmount) return token;
    await new Promise((r) => setTimeout(r, 400));
  }

  throw new Error(
    'Token allowance did not update after approve (network lag). Wait a few seconds and try again.'
  );
}
